<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex order-xs2 order-md2 xs12 md6>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      :error-messages="nameErrors"
                      v-model="$v.userForm.firstName.$model"
                      :label="$t('students.modal_student.name_(s)')"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      :error-messages="lastNameErrors"
                      v-model="$v.userForm.lastName.$model"
                      :label="$t('students.modal_student.last_name')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      :error-messages="levelErrors"
                      :label="$t('students.modal_student.level')"
                      :items="levels"
                      outline
                      height="50"
                      return-object
                      item-text="typeLevel"
                      @change="filterGGsByLevel"
                      :dense="$vuetify.breakpoint.xsOnly"
                      v-model="$v.userForm.level.$model"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      :error-messages="ggErrors"
                      :label="$t('students.modal_student.grade_and_group')"
                      :items="ggs"
                      outline
                      height="50"
                      return-object
                      :item-text="text"
                      v-model="$v.userForm.gg.$model"
                      :dense="$vuetify.breakpoint.xsOnly"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      :error-messages="personIdErrors"
                      v-model="$v.userForm.personId.$model"
                      :label="$t('students.modal_student.student_id')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-radio-group
                      v-model="$v.userForm.gender.$model"
                      color="primary"
                      :error-messages="genderErrors"
                    >
                      <v-radio
                        color="primary"
                        :label="$t('students.modal_student.male')"
                        value="MALE"
                      ></v-radio>
                      <v-radio
                        color="primary"
                        :label="$t('students.modal_student.female')"
                        value="FEMALE"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex style="display: flex">
                    Cumpleaños (opcional)
                    <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template late v-slot:activator="{ on }">
                        <v-text-field
                          id="first-small"
                          :value="dateParse(userForm.birthDate)"
                          label="dd/mm/yyyy"
                          prepend-icon="event"
                          readonly
                          solo
                          flat
                          hide-details
                          v-on="on"
                          class="padded"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :key="forceUpdateCalendar"
                        header-color="primary"
                        color="secondary"
                        locale="es-419"
                        scrollable
                        :max="today"
                        v-model="userForm.birthDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex order-xs1 order-md2 xs8 offset-xs2 md6 offset-md0>
                <v-layout
                  align-center
                  justify-center
                  row
                  wrap
                  v-on:mouseover="flags.updateImage = true"
                  v-on:mouseleave="flags.updateImage = false"
                >
                  <v-flex
                    style="text-align: center"
                    sm7
                    v-show="working.wImage"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-flex>
                  <v-flex
                    v-show="!working.wImage"
                    xs7
                    style="border-radius: 50%"
                    id="parentContainerEmployeeImage"
                    :class="
                      !flags.changed &&
                      (!student ||
                      !student.imageStorage ||
                      !student.imageStorage.miniObjUrl
                        ? 'gradiente'
                        : '')
                    "
                  >
                    <label id="img_edit_employee_default">
                      <v-img
                        v-if="
                          !student ||
                          !student.imageStorage ||
                          !student.imageStorage.miniObjUrl
                        "
                        :src="
                          require('@/assets/panel/modals/AddPhotoIcon@3x.png')
                        "
                      ></v-img>
                      <v-img
                        style="border-radius: 50%; text-align: center"
                        v-else
                        :src="student.imageStorage.miniObjUrl"
                      ></v-img>
                    </label>
                    <label
                      style="display: none; text-align: center"
                      id="img_edit_employee"
                    ></label>

                    <!-- <input
											type="file"
											id="edit_logo"
											name="edit_logo"
											accept="image/*"
											style="display: none;"
											@change="processImage($event)"
                    >-->
                  </v-flex>
                  <br />
                  <v-flex xs7>
                    <v-expand-transition>
                      <v-btn
                        block
                        class="gradiente"
                        style="border-radius: 33px"
                        v-show="flags.updateImage"
                        dark
                        @click="modals.image = true"
                      >
                        {{
                          !student ||
                          !student.imageStorage ||
                          !student.imageStorage.miniObjUrl
                            ? 'Añadir foto'
                            : 'Actualizar'
                        }}
                      </v-btn>
                    </v-expand-transition>
                    <v-expand-transition>
                      <v-btn
                        block
                        class="gradiente"
                        style="border-radius: 33px"
                        v-show="
                          permits &&
                          permits['UPDATE_STUDENTS'] &&
                          flags.updateImage &&
                          student &&
                          student.imageStorage &&
                          student.imageStorage.miniObjUrl
                        "
                        dark
                        @click="modals.confirmDelete = true"
                      >
                        Borrar
                      </v-btn>
                    </v-expand-transition>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="working.wUpdate" flat @click="close">
            {{ $t('students.modal_student.cancel') }}
          </v-btn>
          <v-btn
            :disabled="working.wUpdate"
            color="primary darken-1"
            flat
            @click="submit"
          >
            {{ $t('students.modal_student.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading v-model="working.wUpdate" text="Trabajando..."></loading>
    <success
      v-if="student != null"
      v-model="toast.success"
      text="Creación Exitosa"
    ></success>
    <success
      v-else
      v-model="toast.success"
      text="Actualización Exitosa"
    ></success>
    <error v-model="toast.failed" :text="toast.fmessage"></error>
    <editImage
      :title="userForm.image != null ? 'Editar imagen' : 'Añadir imagen'"
      v-on:loaded="processImage($event)"
      v-model="modals.image"
    ></editImage>
    <desition
      @desition="$event ? deletePhoto() : ''"
      v-model="modals.confirmDelete"
      title="Confirmación"
      description="Al realizar esta acción la foto del alumno dejará de mostrarse y deberás añadir una nueva, ¿Estás seguro de realizar esta acción?"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import desition from '../Dialogs/Confirm'
import error from '../Dialogs/Error.vue'
import loading from '../Dialogs/Loading.vue'
import success from '../Dialogs/Success.vue'
import editImage from '../Modals/EditImage_temp_500_fix_size.vue'

export default {
  props: ['title', 'parent', 'value', 'student', 'permits'],
  components: {
    loading,
    success,
    error,
    editImage,
    desition,
  },
  validations: {
    userForm: {
      firstName: { required },
      lastName: { required },
      gender: { required },
      personId: { required },
      level: { required },
      gg: { required },
    },
  },
  watch: {
    value() {
      this.getLevels()
    },
  },

  mounted() {},
  data: () => ({
    forceUpdateCalendar: Math.random(),
    today: moment().format('YYYY-MM-DD'),
    modals: {
      image: false,
      confirmDelete: false,
    },
    userForm: {
      firstName: '',
      lastName: '',
      gender: '',
      personId: '',
      level: {},
      gg: {},
      qrEnabled: false,
      birthDate: undefined,
    },
    userImg: null,
    working: {
      wUpdate: false,
      wImage: false,
    },
    toast: {
      success: false,
      failed: false,
      fmessage: 'Ups ocurrió un error',
    },
    flags: {
      updateImage: false,
      changed: false,
    },
    levels: [],
    ggs: [],
    selectedLevel: {},
    stdIdToAdd: {},
    momenta: moment,
  }),
  methods: {
    dateParse(date) {
      if (date != null) {
        return moment(date).format('DD/MM/YYYY')
      }
      return 'dd/mm/yyyy'
    },
    deletePhoto() {
      this.$emit('deletePhoto', this.student.id)
    },
    text: (item) => item.grade + '' + item.group,
    setInfoToShowOnUpdate() {
      if (this.value) {
        if (this.student != null) {
          this.userForm.id = this.student.id
          this.userForm.firstName = this.student.firstName
          this.userForm.lastName = this.student.lastName
          this.userForm.personId = this.student.personId
          this.userForm.gender = this.student.gender
          this.userForm.personId = this.student.personId
          this.userForm.level = this.student.level
          this.userForm.qrEnabled = this.student.qrEnabled
          this.userForm.birthDate =
            this.student.birthDate !== undefined
              ? moment(this.student.birthDate).format('YYYY-MM-DD')
              : undefined

          // clear date
          this.userForm.birthDate === undefined
            ? moment(Date.now()).format('YYYY-MM-DD')
            : this.userForm.birthDate
          this.forceUpdateCalendar = Math.random()

          for (var lvl in this.levels) {
            if (this.student.level.id == this.levels[lvl].id) {
              this.ggs = this.levels[lvl].ggs
              this.$forceUpdate()
              break
            }
          }
          this.userForm.gg = this.student.gg
          if (
            this.student.image != null &&
            this.student.image != '' &&
            this.student.image != 'data:image/jpeg;base64,undefined' &&
            this.student.image != 'data:image/jpeg;base64,' &&
            this.student.image != 'data:image/jpeg;base64, '
          ) {
            this.processImage(this.student.image)
          }
        }
      }
    },
    getLevels() {
      this.working.wUpdate = true
      this.$store
        .dispatch('tutor/getLevelsParentTool')
        .then((response) => {
          this.levels = response.data.entity.levels
          this.working.wUpdate = false
          this.setInfoToShowOnUpdate()
        })
        .catch((error) => {
          console.log(error)
          this.working.wUpdate = false
          this.toast.failed = true
        })
    },

    processImage(event) {
      this.working.wImage = true
      this.userForm.image = event.split(',')[1]
      document.getElementById(
        'img_edit_employee'
      ).innerHTML = `<img class="elevation-4" src="${event}" style='width: 146px; height: 146px; object-fit: cover; border-radius: 50%;'>`
      document.getElementById('img_edit_employee').style.display = 'block'
      document.getElementById('img_edit_employee_default').style.display =
        'none'
      this.working.wImage = false
      this.flags.changed = true
    },
    submit() {
      this.$v.userForm.$touch()
      if (!this.$v.userForm.$invalid) {
        this.working.wUpdate = true
        if (this.student == null) {
          const obj = {
            ...this.userForm,
            birthDateS:
              this.userForm.birthDate !== undefined
                ? moment(this.userForm.birthDate).format('YYYY-MM-DD')
                : undefined,
          }

          this.$store
            .dispatch('student/createStudent', obj)
            .then((response) => {
              this.stdIdToAdd = response.data.entity

              if (this.parent != null) {
                this.$store
                  .dispatch('tutor/addChildToParent', {
                    pid: this.parent,
                    sid: this.stdIdToAdd.id,
                  })
                  .then((res) => {
                    this.working.wUpdate = false
                    this.$v.$reset()
                    this.$emit('created', response.data.entity)
                    this.close()
                  })
                  .catch((error) => {
                    this.working.wUpdate = false
                    this.toast.failed = true
                    if (error.status == 200) {
                      this.toast.fmessage = error.data.message
                    }
                    console.log(error)
                  })
              } else {
                this.working.wUpdate = false
                this.$emit('created', response.data.entity)
                this.close()
              }
            })
            .catch((error) => {
              this.working.wUpdate = false
              this.toast.failed = true
              if (error.status == 200) {
                this.toast.fmessage = error.data.message
              }
              console.log(error)
            })
        } else {
          const obj = {
            ...this.userForm,
            birthDateS:
              this.userForm.birthDate !== undefined
                ? moment(this.userForm.birthDate).format('YYYY-MM-DD')
                : undefined,
          }

          this.$store
            .dispatch('student/updateStudent', obj)
            .then((response) => {
              this.working.wUpdate = false
              this.$v.$reset()
              this.toast.success = true
              response.data.entity.image =
                'data:image/jpeg;base64,' + response.data.entity.image

              this.$emit('updated', response.data.entity)
              this.close()
            })
            .catch((error) => {
              this.working.wUpdate = false
              this.toast.failed = true
              if (error.status == 200) {
                this.toast.fmessage = error.data.message
              }
              console.log(error)
            })
        }
      }
    },
    close() {
      this.$v.$reset()
      document.getElementById('img_edit_employee').innerHTML = ``
      document.getElementById('img_edit_employee').style.display = 'none'
      document.getElementById('img_edit_employee_default').style.display =
        'block'
      this.flags.changed = false

      this.userForm = {
        firstName: '',
        lastName: '',
        gender: '',
        personId: '',
        level: {},
        gg: {},
        birthDate: undefined,
      }
      this.$emit('input', !this.value)
      this.$emit('onClosed', false)
    },
    filterGGsByLevel(val) {
      this.levels.filter((item) => {
        if (item.id == val.id) {
          this.ggs = item.ggs
          this.$forceUpdate()
        }
      })
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.close()
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },

  computed: {
    levelErrors() {
      const errors = []
      if (!this.$v.userForm.level.$dirty) return errors
      !this.$v.userForm.level.required && errors.push('Nivel obligatorio')

      return errors
    },
    ggErrors() {
      const errors = []
      if (!this.$v.userForm.gg.$dirty) return errors
      !this.$v.userForm.gg.required && errors.push('Grado y grupo obligatorios')

      return errors
    },

    personIdErrors() {
      const errors = []
      if (!this.$v.userForm.personId.$dirty) return errors
      !this.$v.userForm.personId.required &&
        errors.push('Matrícula obligatoria')

      return errors
    },
    lastNameErrors() {
      const errors = []
      if (!this.$v.userForm.lastName.$dirty) return errors
      !this.$v.userForm.lastName.required &&
        errors.push('Apellidos obligatorios')

      return errors
    },
    nameErrors() {
      const errors = []
      if (!this.$v.userForm.firstName.$dirty) return errors
      !this.$v.userForm.firstName.required && errors.push('Nombre obligatorio')
      return errors
    },
    genderErrors() {
      const errors = []
      if (!this.$v.userForm.gender.$dirty) return errors
      !this.$v.userForm.gender.required && errors.push('Genero obligatorio')
      return errors
    },
  },
}
</script>

<style>
.no-properties {
  width: 0% !important;
  height: 0% !important;
}
</style>
